import React, { useState } from 'react';
import { useStore } from '../../store/useStore';
import { MonitorPlay, CheckCircle2, XCircle, Link as LinkIcon, Loader2 } from 'lucide-react';

export function M8_MetaAds() {
  const { connections, setConnections } = useStore();
  const [isConnecting, setIsConnecting] = useState(false);

  const handleConnect = () => {
    setIsConnecting(true);
    setTimeout(() => {
      setIsConnecting(false);
      setConnections({ metaConnected: true });
    }, 2000);
  };

  const isConnected = connections.metaConnected;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-gray-900">Integração Meta Ads</h2>
        <p className="text-gray-500 mt-1">
          Conecte a conta de anúncios e o Business Manager (BM) do cliente.
        </p>
      </div>

      <div className={`p-8 rounded-xl border-2 transition-all ${isConnected ? 'bg-green-50/50 border-green-200' : 'bg-white border-gray-200'}`}>
         <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className={`p-4 rounded-full ${isConnected ? 'bg-green-100' : 'bg-blue-50'}`}>
                <MonitorPlay size={32} className={isConnected ? 'text-green-600' : 'text-blue-600'} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Facebook & Instagram Ads</h3>
                <div className="flex items-center gap-2 mt-1">
                  {isConnected ? (
                     <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                        <CheckCircle2 size={14} /> Conectado e Sincronizando
                     </span>
                  ) : (
                     <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                        <XCircle size={14} /> Pendente
                     </span>
                  )}
                </div>
              </div>
            </div>

            <div>
              {isConnected ? (
                <button 
                  onClick={() => setConnections({ metaConnected: false })}
                  className="px-4 py-2 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium"
                >
                  Desconectar
                </button>
              ) : (
                <button 
                  onClick={handleConnect}
                  disabled={isConnecting}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isConnecting ? <Loader2 size={18} className="animate-spin" /> : <LinkIcon size={18} />}
                  {isConnecting ? 'Conectando...' : 'Conectar Business Manager'}
                </button>
              )}
            </div>
         </div>
         
         {isConnected && (
            <div className="mt-8 pt-8 border-t border-green-200/50 grid grid-cols-1 md:grid-cols-3 gap-6">
               <div className="bg-white p-4 rounded-xl border border-green-100 shadow-sm">
                  <p className="text-sm font-medium text-gray-500">ID da Conta</p>
                  <p className="font-mono text-gray-900 mt-1">act_18374928374</p>
               </div>
               <div className="bg-white p-4 rounded-xl border border-green-100 shadow-sm">
                  <p className="text-sm font-medium text-gray-500">Campanhas Ativas</p>
                  <p className="font-bold text-gray-900 text-xl mt-1">14</p>
               </div>
               <div className="bg-white p-4 rounded-xl border border-green-100 shadow-sm">
                  <p className="text-sm font-medium text-gray-500">Gasto Últimos 7 dias</p>
                  <p className="font-bold text-gray-900 text-xl mt-1">R$ 4.250</p>
               </div>
            </div>
         )}
      </div>
    </div>
  );
}
